import { getInstance } from "./index";
export const emailGuard = (to, from, next) => {
    const authService = getInstance();

    async function fn() {
        if (!authService.isAuthenticated) {
            authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
          }
        if (authService.user.email_verified) {
            return next("/profil");
        }
        return next();
    }

    // If loading has already finished, check our auth state using `fn()`
    if (!authService.loading) {
        return fn();
    }

    // Watch for the loading property to change before we check isAuthenticated
    authService.$watch("loading", loading => {
        if (loading === false) {
            return fn();
        }
    });
};